import React from 'react';
import { JUVCard } from '@/components/juv';
import { Syringe } from 'lucide-react';

const VitaminInjectionsSection = () => {
  const vitamins = [
    'B12',
    'MIC',
    'B Complex',
    'Glutathione',
    'Vitamin C',
    'Vitamin D'
  ];

  return (
    <JUVCard
      title="💉 Vitamin Injections"
      icon={Syringe}
      variant="glass"
      className="mb-8"
    >
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-juv-terracotta">$50 Each</h3>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {vitamins.map((vitamin, index) => (
          <div 
            key={index}
            className="p-4 bg-juv-soft-blush/30 rounded-lg text-center hover:bg-juv-rose-clay/30 transition-colors"
          >
            <span className="text-juv-deep-chestnut font-medium">
              {vitamin}
            </span>
          </div>
        ))}
      </div>
    </JUVCard>
  );
};

export default VitaminInjectionsSection;
